/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Předchozí`
};

const da_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Forrige`
};

const de_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück`
};

const en_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Previous`
};

const es_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Anterior`
};

const fr_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Précédent`
};

const hu_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Előző`
};

const it_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Precedente`
};

const nl_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Vorige`
};

const pl_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Poprzedni`
};

const pt_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Anterior`
};

const sv_previous = /** @type {(inputs: {}) => string} */ () => {
	return `Föregående`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const previous = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.previous(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("previous", locale)
	if (locale === "cs") return cs_previous(inputs)
	if (locale === "da") return da_previous(inputs)
	if (locale === "de") return de_previous(inputs)
	if (locale === "en") return en_previous(inputs)
	if (locale === "es") return es_previous(inputs)
	if (locale === "fr") return fr_previous(inputs)
	if (locale === "hu") return hu_previous(inputs)
	if (locale === "it") return it_previous(inputs)
	if (locale === "nl") return nl_previous(inputs)
	if (locale === "pl") return pl_previous(inputs)
	if (locale === "pt") return pt_previous(inputs)
	return sv_previous(inputs)
};